module.exports = __webpack_public_path__ + "static/cordelia--name-99bcc5cac02a7fbb41ad3fd311c1b1e0.png";